module.exports = __webpack_public_path__ + "img/Icon-A.64261684.png";